import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Container,
  TextField,
  Select,
  MenuItem,
  Button,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography, Box, 
} from "@mui/material";
import { useNavigate } from "react-router-dom";

function Catalogo() {
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [filters, setFilters] = useState({
    category: "",
    search: "",
    minPrice: "",
    maxPrice: "",
  });
  const navigate = useNavigate();

  // Buscar categorias
  useEffect(() => {
    axios.get("http://localhost:5000/categories").then((res) => {
      setCategories(res.data);
    });
  }, []);

  // Buscar produtos
  const fetchProducts = () => {
    axios.get("http://localhost:5000/products", { params: filters }).then((res) => {
      setProducts(res.data);
    });
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  // Enviar id do produto para a página do produto

  const handleProductClick = (productId) => {
    navigate(`/product/${productId}`);
  };


  return (
    <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3 } }}> {/* maxWidth aumentado para xl e padding responsivo */}
      {/* Buscador */}
      <Box sx={{ 
        backgroundColor: "#f2f2f2", 
        py: 3, 
        mb: 3, 
        width: "100%", // Alterado de 100vw para 100%
        mx: 'auto', // Centralização
        px: { xs: 2, sm: 0 } // Padding responsivo
      }}>
        <Typography variant="h5" align="center" sx={{ fontWeight: "bold", mb: 2, color: "#777777" }}>
          BUSCADOR
        </Typography>
        <Grid 
          container 
          spacing={0}
          sx={{
            maxWidth: 800, // Ajuste conforme necessário
            margin: '0 auto',
            border: '1px solid #ddd',
            borderRadius: 1,
            backgroundColor: "white",
            overflow: 'hidden',
            '& .MuiGrid-item': {
              borderRight: '1px solid #ddd',
              '&:last-child': { borderRight: 'none' }
            }
          }}
        >
        <Grid item xs={12} sm sx={{ flex: 1 }}>
          <Select
            fullWidth
            size="small"
            sx={{
              fontSize: '12px',
              borderRadius: 0,
              '& fieldset': { border: 'none' }
            }}
            displayEmpty
            onChange={(e) => setFilters({ ...filters, category: e.target.value })}
            renderValue={(selected) => {
              if (!selected) {
                return <span style={{ color: '#999' }}>Selecione uma categoria</span>;
              }
              return selected;
            }}
            >
            <MenuItem value="" sx={{ fontSize: '12px'}}>Todas as Categorías</MenuItem>
            {categories.map((cat) => (
              <MenuItem sx={{ fontSize: '12px'}} key={cat.id} value={cat.name}>
                {cat.name}
              </MenuItem>
            ))}
          </Select>
        </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              fullWidth
              size="small"
              sx={{
                '& .MuiInputBase-root': {
                  borderRadius: 0,
                  fontSize: '12px',
                },
                '& fieldset': { border: 'none' }
              }}
              placeholder="Búsqueda"
              value={filters.search}
              onChange={(e) => setFilters({ ...filters, search: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextField
              fullWidth
              size="small"
              sx={{
                '& .MuiInputBase-root': {
                  borderRadius: 0,
                  fontSize: '12px'
                },
                '& fieldset': { border: 'none' }
              }}
              placeholder="Desde Precio..."
              type="number"
              value={filters.minPrice}
              onChange={(e) => setFilters({ ...filters, minPrice: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextField
              fullWidth
              size="small"
              sx={{
                '& .MuiInputBase-root': {
                  borderRadius: 0,
                  fontSize: '12px',
                },
                '& fieldset': { border: 'none' }
              }}
              placeholder="Hasta Precio..."
              type="number"
              value={filters.maxPrice}
              onChange={(e) => setFilters({ ...filters, maxPrice: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Button
              fullWidth
              size="small"
              sx={{
                fontSize: '12px',
                color: "white",
                fontWeight: "bold",
                borderRadius: 0,
                height: 40, // Altura fixa para igualar aos inputs
                backgroundColor: "#B3A6D2",
                '&:hover': { backgroundColor: "#9c8fb9" }
              }}
              onClick={fetchProducts}
            >
              Buscar
            </Button>
          </Grid>
        </Grid>
      </Box>

      {/* Lista de Productos */}
      <Grid container spacing={3} sx={{ mt: 3, width: '100%' }}> {/* Removido o width fixo */}
        {products.map((product) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={product.id}> {/* Ajuste dos breakpoints */}
            <Card sx={{ display: "flex", flexDirection: "column", height: "100%" }} onClick={() => handleProductClick(product.id)}>
              <CardMedia 
                component="img" 
                height="200" 
                image={`http://localhost:5000/images/products/${product.image_url}`} 
                alt={product.name} 
                sx={{ objectFit: "cover" }} // Garante que a imagem ocupe corretamente o espaço sem margens extras
              />
              <CardContent sx={{ flexGrow: 1, paddingBottom: "0 !important", paddingTop: 1, display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                <Typography variant="h6" fontWeight="bold" sx={{ fontSize: "16px" }}>
                  {product.name}
                </Typography>
                <Typography variant="body2" sx={{ fontSize: "13px", flexGrow: 1 }}>
                  {product.description}
                </Typography>
                <Typography 
                  variant="h6" 
                  color="primary" 
                  sx={{ fontSize: "14px", fontWeight: "bold", textAlign: "right", marginTop: "auto", mb: 0, pb: 0 }}
                >
                  ${product.price}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      <br></br>
      <br></br>
    </Container>
  );
}

export default Catalogo;
